module.exports = __webpack_public_path__ + "static/media/SeaShip-night.7bc43a83.svg";